import * as React from "react";
import { useTranslation } from "react-i18next";
import { translatedOptions, visT } from "views/components/visualizations/visualizationTranslation";
import NumberVisualization from "views/components/visualizations/number/NumberVisualization";
import NumberVisualizationConfig, {
  DEFAULT_COLOR_PREFERENCE
} from "views/logic/aggregationbuilder/visualizations/NumberVisualizationConfig";
const TrendHelp = () => {
  const { t } = useTranslation("aggregation");
  return /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement("p", null, t("vis_number.trend_help_enabled")), /* @__PURE__ */ React.createElement("p", null, t("vis_number.trend_help_previous")));
};
const singleNumber = {
  type: NumberVisualization.type,
  get displayName() {
    return visT("vis_types.single_number");
  },
  component: NumberVisualization,
  config: {
    createConfig: () => ({ color_preference: DEFAULT_COLOR_PREFERENCE }),
    fromConfig: (config) => {
      var _a;
      return {
        trend: config == null ? void 0 : config.trend,
        trend_preference: config == null ? void 0 : config.trendPreference,
        color_preference: (_a = config == null ? void 0 : config.colorPreference) != null ? _a : DEFAULT_COLOR_PREFERENCE
      };
    },
    toConfig: ({
      trend = false,
      trend_preference,
      color_preference = DEFAULT_COLOR_PREFERENCE
    }) => NumberVisualizationConfig.create(trend, trend_preference, void 0, color_preference),
    fields: [
      {
        name: "trend",
        get title() {
          return visT("vis_number.trend");
        },
        type: "boolean",
        get description() {
          return visT("vis_number.trend_description");
        },
        helpComponent: TrendHelp
      },
      {
        name: "trend_preference",
        get title() {
          return visT("vis_number.trend_preference");
        },
        type: "select",
        get options() {
          return translatedOptions(["LOWER", "NEUTRAL", "HIGHER"], "vis_number.trend_preferences");
        },
        required: true,
        isShown: (formValues) => (formValues == null ? void 0 : formValues.trend) === true
      },
      {
        name: "color_preference",
        get title() {
          return visT("vis_number.highlight");
        },
        type: "select",
        get options() {
          return translatedOptions(["TREND_ONLY", "FULL_WIDGET"], "vis_number.highlight_options");
        },
        required: true,
        isShown: (formValues) => (formValues == null ? void 0 : formValues.trend) === true && ((formValues == null ? void 0 : formValues.trend_preference) === "HIGHER" || (formValues == null ? void 0 : formValues.trend_preference) === "LOWER")
      }
    ]
  }
};
export default singleNumber;
